export const newtinMixin = {
  methods: {
    getNewtinUrl: function(windowLocation) {
      if (this.isProductionEnvironment(windowLocation)) {
        return "https://newtin.co811.org/newtinweb";
      } else {
        return "https://uncca.newtin.com/newtinweb";
      }
    },
    isProductionEnvironment: function(url) {
      return url && url.includes("amazonaws.com");
    }
  }
};
